/* eslint-disable */
import axios from "axios";
import managePatientModal from "../managePatientModal/managePatientModal.vue";
import manageVisitModal from "../manageVisitModal/manageVisitModal.vue";
import manageSoAModal from "../ManageSoAModal/ManageSoAModal.vue";
import store from "../../store/index";
import moment from "moment";
import VPagination from "@hennge/vue3-pagination";
import CreateSitePopUp from "../CreateSitePopUp/CreateSitePopUp.vue";
import EditStudyPopUp from "../EditStudyPopUp/EditStudyPopUp.vue";
import createnewversion from "../newversion/createnewversion.vue";
import retireFormPopUp from "../retireFormPopUp/retireFormPopUp.vue";
import ChangeCategory from "../ChangeCategoryPopup/ChangeCategory.vue";
import importForms from "../importForms/importForms.vue";
import Forms_AI_PopUp from "../Forms_AI_PopUp/Forms_AI_PopUp.vue";
import Multiselect from "@vueform/multiselect";
import VisitActivityModal from "../VisitActivityOrder/VisitActivityOrder.vue"
import customModal from "../customModal/customModal.vue";
import ActivityFormTemplate from "../ActivityFormTemplate/ActivityFormTemplate.vue";
import showformmodel from "../showformmodel/showformmodel.vue" 
import jwt_decode from "jwt-decode";
import ApproveRejectPopUp from "../ApproveRejectPopUp/ApproveRejectPopUp.vue";
export default {
  name: "studyProfile",
  props: {soAId: String},
  components: {
    VPagination,
    managePatientModal,
    manageVisitModal,
    manageSoAModal,
    CreateSitePopUp,
    EditStudyPopUp,
    createnewversion,
    retireFormPopUp,
    customModal,
    showformmodel,
    Multiselect,
    importForms,
    ActivityFormTemplate,
    Forms_AI_PopUp,
    ChangeCategory,
    VisitActivityModal,
    ApproveRejectPopUp
  },
  data() {
    return {
      isUpdating: false,
      isCreating: false,
      baseurl: process.env.VUE_APP_Service_URL,
      showSiteModal: false,
      showPatientModal: false,
      showFormsModal: false,
      setshowActivityFormModal: false,
      showcategoryModal: false,
      token: store.getters.getIdToken,
      head: "",
      // -- pagination -- 
      pageSize: 10,
      totalTemplatePages: 1,
      currentTemplatePage: 1,
      studyId :"",
      totalVisitPages: 1,
      currentVisitiPages: 1,
      soaTotalPages: 1,
      soaCurrentPage: 1,

      showSidePopup: [false],
      showVisitPopup: [false],
      showSoaPopup: [false],
      studyDetails: {},
      studyTemplates: "",
      ecrfLoading:true,
      defaultdate: "",
      visitList: "",
      visitsLoading:true,
      isSelectedUser: [],
      isRequired: [],
      studyId: "",
      id: "",
      visitId: "",
      siteModal: false,

      selectedDueDate: null,
      showAssignTemplate: false,
      studyEditModal: false,
      newtemplate: "",
      creatversionpopup: false,
      newversionformid: "",
      version:"",
      templatelist: [],
      permissiontemplatlist: [],
      selectedTemplateIds: [],
      selectedvisitid: "",
      sourceId: "",
      SelectedVisitId: "",
      sourceVersion: "",
      retireFormModal: false,
      rollsprivilages: "",
      AIpopup: false,
      formItems: [],
      templates: [],
      soAItem: {},
       showLoading: false,
      values: {
        modelName: "StudyDIsName",
        description: "",
        threshold: 0.7
      },
      showLoadingAnimation: false,
      clicked: false,
      showVisitForms: false,
      showActivityForms: false,
      formsArray: [],
      SoAList: [],
      selectedVersion: "",
      documentApprovalModal: false,
      versionList: [],
      activitiesLoading:true,
      showActivityFormModal: false,
      activityType: "",
      CurrentVersion: "",
      showSoAModal: false,
      currentVisitiPages: 1,
      // soAId: "",
      addPrivilegeModal: false,
      addPrivilegebutton: true,
      roleList: [],
      selectedTemplateId: [],
      selectedRoleList: [],
      rolesAndPrivilegelist: {},
      temprolesAndPrivilegelist: {},
      selectedPrivilegeList: [],
      pageindex: 1,
      currentPage: 1,
      SortProperty: "createdAt",
      visitSortProperty:"visitNo",
      SortTemplateProperty:"templateName",
      visitSortOrder:0,
      SortTemplateOrder:0,
      SortOrder: 1,
      selectedcolumnobj: {},
      showActivityModal: false,
      privilegeList: [
        { value: "Add", label: "Add" },
        { value: "View", label: "View" },
        { value: "Edit", label: "Edit" },
      ],
      loadingSaveModalBtn: false,
      userList: [],
      showSave: false,
      designation: "",
      user:{},
      userobject: [],
      loadingSingleSave: [false],
      designationList: [],
      roleList: [],
  
      userobject: {},
      isSelectedUser: [],
      isRequired: [],
      isDisabled: [],
      loadingSingleSave: [],
      loadingSaveModalBtn: false,
      selectedDueDate: "",
      studyId: "",
      selectedVersion: "",
      approvals: {
        studyId: "",
        version: "",
        actionType: "approval",
        approveList: [],
      },
      existingApprovers: [],
      showApproveRejectPopup: false,
      showActivateBtn: false,
      showApproveBtn: false,
      activityId: "",
    };

  },
  watch: {
    studyTemplates: {
      handler() {
        this.initializeColumns();
      },
      immediate: true,
      deep: true,
    },
    visitList: {
      handler() {
        this.initializeColumns();
      },
      immediate: true,
      deep: true,
    },
    SoAList: {
      handler() {
        this.initializeColumns();
      },
      immediate: true,
      deep: true,
    },
  },
  async mounted() {
    this.head = {
      headers: {
        Authorization: "Bearer " + this.token,
        "Content-Type": "application/json",
      },
    },
    await this.getUserDetails();

    this.defaultdate = localStorage.getItem("dateformat");
    this.rollsprivilages = await store.getters.getRolesprivilegeData;
    window.addEventListener("studyIdChanged", async () => {
      this.studyId = store.getters.getStudyIs
      await this.listVersionTypes(this.studyId);
      this.selectedVersion = Array.isArray(this.versionList) && this.versionList.length > 0
                                ? this.versionList[0]
                                : "";
      await this.getStudyDetails().then(() => {
        this.updateDisabledUsers();
      });
      await this.setBtnVisibility();
      await this.listStudyTemplate();
      await this.templateList();
      await this.listVisit();
      await this.listSOAs(); 
    });
    this.studyId = store.getters.getStudyIs
    if (this.studyId == null || this.studyId == "") {
      alert(this.$t('navigations.no study selected'))
    }
    else {
      await this.listVersionTypes(this.studyId);
      this.selectedVersion = Array.isArray(this.versionList) && this.versionList.length > 0
                                ? this.versionList[0]
                                : "";
      await this.getStudyDetails().then(() => {
        this.updateDisabledUsers();
      });
      
      await this.listStudyTemplate();
      await this.templateList();
      await this.listVisit();
      await this.listSOAs();
      console.log("Study Profile mounted before set visibilty");
      await this.setBtnVisibility();
    }

  },

  computed: {
    isLatestVersionSelected() {
    if (!this.versionList || this.versionList.length === 0) return false;
    return this.selectedVersion === this.versionList[this.versionList.length - 1];
    },
    privilegeRows() {
      // each row: { roleId, templateId, roleName, templateName }
      return this.selectedRoleList.flatMap(roleId =>
        this.selectedTemplateIds.map(templateId => {
          const tmpl = this.templates.find(t => t.templateId === templateId) || {};
          return {
            roleId,
            templateId,
            roleName: this.fetchRoleName(roleId),
            templateName: tmpl.templateName
          };
        })
      );
    },
    selectedmodeltemplate() {
      return this.selectedTemplateIds.map(id => {
        return this.templatelist.find(template => template.templateId === id);
      });
    }
  },
  methods: {
    onPrivilegeChange(row, privilege, event) {
      const { roleId, templateId } = row;
      const arr = this.rolesAndPrivilegelist[roleId][templateId];
      const checked = event.target.checked;
      const idx = arr.indexOf(privilege);

      if (checked && idx === -1) {
        // 1) add the clicked privilege
        arr.push(privilege);

        // 2) enforce upward rules
        if (privilege === 'Add') {
          if (!arr.includes('View')) arr.push('View');
          if (!arr.includes('Edit')) arr.push('Edit');
        }
        else if (privilege === 'Edit') {
          if (!arr.includes('View')) arr.push('View');
        }
      }
      else if (!checked && idx !== -1) {
        // 1) remove the clicked privilege
        arr.splice(idx, 1);

        // 2) enforce downward rules
        if (privilege === 'View') {
          // unchecking view removes both Add & Edit
          ['Add', 'Edit'].forEach(p => {
            const i = arr.indexOf(p);
            if (i !== -1) arr.splice(i, 1);
          });
        }
        else if (privilege === 'Edit') {
          const idx = arr.indexOf('Add');
          if (idx !== -1) arr.splice(idx, 1);
        }
      }

      // force Vue to detect the change
      this.rolesAndPrivilegelist = { ...this.rolesAndPrivilegelist };
    },
    onRoleChange(newRoles) {
      // 1) update selectedRoleList
      this.selectedRoleList = newRoles;

      // 2) for each newly-added role, ensure a map and empty arrays exist
      newRoles.forEach(rid => {
        if (!this.rolesAndPrivilegelist[rid]) {
          // create the template-map object
          this.rolesAndPrivilegelist[rid] = {};
        }
        this.selectedTemplateIds.forEach(tid => {
          if (!Array.isArray(this.rolesAndPrivilegelist[rid][tid])) {
            this.rolesAndPrivilegelist[rid][tid] = [];
          }
        });
      });

      // (we’re intentionally not deleting old rid keys so that re-selecting preserves previous choices)
    },

    onTemplateChange(newTemps) {
      // 1) update selectedTemplateIds
      this.selectedTemplateIds = newTemps;

      // 2) for each newly-added template, ensure every selected role has an array
      newTemps.forEach(tid => {
        this.selectedRoleList.forEach(rid => {
          const roleMap = this.rolesAndPrivilegelist[rid] || (this.rolesAndPrivilegelist[rid] = {});
          if (!Array.isArray(roleMap[tid])) {
            roleMap[tid] = [];
          }
        });
      });

      // (again, don’t remove old tid keys)
    },
   
    fetchRoleName(roleID) {
      const role = this.roleList.find(r => r.roleID === roleID)
      return role
        ? role.roleName
        : ''      // or return a default/fallback
    },
     goToCreateNewVersion(){
+      this.$router.push(`/studyProfile`);
     },   
    // study data excel automation Starts
    filterDate(date) {
      if (date) {
        return moment(date).format(this.defaultdate);
      }
    },
    loadTemplate: function (page) {
      this.currentTemplatePage = page;
      this.listStudyTemplate();
      this.templateList();
    },
    loadVisit: function (page) {
      this.currentVisitiPages = page;
      this.listVisit();
    },
    loadSoA: function (page) {
      this.soaCurrentPage = page;
      this.listSOAs();
    },
    async privilegeform() {
      // reset everything
      this.selectedRoleList = [];
      this.selectedTemplateIds = [];
      this.rolesAndPrivilegelist = {};

      // ensure we have the up-to-date list of roles
      await this.getRoleList();

      // now fetch privileges (no roleId filter)
      await this.getFormPrivilege();
      await this.templateList();

      // only now display the popup
      this.addPrivilegeModal = true;
    },
    closePrivilege() {
      this.addPrivilegeModal = false;
      this.selectedRoleList = [];
      this.selectedTemplateIds = [];
      this.rolesAndPrivilegelist = {};
    },
    openretireModal(id, versionNo) {
      this.retireFormModal = true
      this.sourceId = id
      this.sourceVersion = versionNo
    },
    openCategoryModal(tempId, category) {
      this.showcategoryModal = true;
      this.selectedTemplateId = tempId;
      this.selectedCategory = category;

    },
    async getStudyDetails() {
      try {
        const res = await axios.get(
          `${this.baseurl}/management/study/getbyid?id=${this.studyId}&version=${this.selectedVersion}`,
          this.head
        );
        this.studyDetails = res.data;
        return res;
      } catch (err) {
        console.error("Error in get study:", err);
      }
    },
    async getRoleList() {
      axios.get(`${this.baseurl}/account-core/roles/rolelist`, this.head)
        .then((res) => {
          this.roleList = res.data;
        })
        .catch(err => console.log("error in get study", err));
    },
    isAllSelected(col) {
      return this.privilegeRows.every(row => {
        const arr = this.rolesAndPrivilegelist[row.roleId][row.templateId] || [];
        return arr.includes(col);
      });
    },
    toggleColumn(privilege, event) {
      const checked = event.target.checked;

      this.privilegeRows.forEach(row => {
        const arr = this.rolesAndPrivilegelist[row.roleId][row.templateId];

        if (checked) {
          // 1) add the clicked privilege
          if (!arr.includes(privilege)) arr.push(privilege);

          // 2) enforce upward rules
          if (privilege === 'Add') {
            if (!arr.includes('View')) arr.push('View');
            if (!arr.includes('Edit')) arr.push('Edit');
          }
          else if (privilege === 'Edit') {
            if (!arr.includes('View')) arr.push('View');
          }
        }
        else {
          // 1) remove the clicked privilege
          const i = arr.indexOf(privilege);
          if (i !== -1) arr.splice(i, 1);

          // 2) enforce downward rules
          if (privilege === 'View') {
            ['Add', 'Edit'].forEach(p => {
              const idx = arr.indexOf(p);
              if (idx !== -1) arr.splice(idx, 1);
            });
          }
          else if (privilege === 'Edit') {
            const idx = arr.indexOf('Add');
            if (idx !== -1) arr.splice(idx, 1);
          }
        }
      });

      // Force Vue reactivity
      this.rolesAndPrivilegelist = { ...this.rolesAndPrivilegelist };
    },
    async createFormPrivilege() {
      // 1) validation
      if (this.selectedRoleList.length === 0) {
        alert(this.$t("navigations.please select role and privilege"));
        return;
      }
      if (this.selectedTemplateIds.length === 0) {
        alert(this.$t("navigations.no template selected"));
        return;
      }
      this.isCreating = true;
      // 2) build payload
      const payload = this.formatPrivileges(
        this.rolesAndPrivilegelist,
        this.selectedTemplateIds
      );

      // 3) send
      try {
        const res = await axios.post(
          `${this.baseurl}/forms/formsprivilege/createprivilege`,
          payload,
          this.head
        );
        console.log("Privilege created", res.data);
        this.isCreating = false;
        alert(this.$t("navigations.privilege created successfully"));
        this.addPrivilegebutton = false;
        this.listStudyTemplate();
        // 4) reset modal
      } catch (err) {
        console.error("error in creating privilege", err);
        alert(this.$t("navigations.failed to create privilege"));
      }
    },
    formatPrivileges(rolesAndPrivilegelist, templateIds) {
      // rolesAndPrivilegelist: { [roleId]: { [templateId]: ["Add","View",…] } }
      const rolePrivileges = Object.entries(rolesAndPrivilegelist).map(
        ([roleId, templatesMap]) => {
          // build one permission block per template
          const permission = templateIds.map(templateId => {
            const tmpl = this.templates.find(t => t.templateId === templateId) || {};
            // grab exactly that template's array of privileges
            const privileges = Array.isArray(templatesMap[templateId])
              ? templatesMap[templateId]
              : [];
            return {
              templateId,
              templateName: tmpl.templateName || "",
              // shallow copy to avoid accidental mutation
              privileges: privileges.slice()
            };
          });
          return { roleId, permission };
        }
      );

      return {
        studyId: this.studyId,
        rolePrivileges
      };
    },
    async listVersionTypes(studyId) {
      try {
        const res = await axios.get(
          `${this.baseurl}/management/study/studyversionlist`,
          {
            ...this.head,
            params: { studyId, isActive: false }
          }
        );
        this.versionList = res.data;
         if (Array.isArray(this.versionList) && this.versionList.length > 0) {
      this.selectedVersion = this.versionList[this.versionList.length - 1];
    }
      } catch (err) {
        console.error("Error listing versions:", err);
      }
    },
    async closeDocumentApprovalModal() {
      console.log("Closing document approval modal..........................");
      this.roleList = [];
      this.designation = "";
      this.designationList = [];
      this.userList = [];
      this.documentApprovalModal = false;
      this.selectedApprovalType = "";
      this.selectedDueDate = "";
      this.showSave = false;

      await this.getStudyDetails().then(() => {
              this.updateDisabledUsers();
      });
      await this.setBtnVisibility();
    },
    async onVersionChange() {
      try {
        console.log("Selected version changed to:", this.selectedVersion);
        //await this.getStudyDetails(this.selectedVersion);
        await this.listVisit();
        await this.listSOAs();
        await this.listStudyTemplate();
      } catch (error) {
        console.error("Error fetching study details for version:", error);
      }
    },

    async getFormPrivilege(roleId = null) {
      const token = store.getters.getIdToken;
      const params = { studyId: this.studyId };
      if (roleId != null) params.roleId = roleId;

      try {
        const { data } = await axios.get(
          `${this.baseurl}/forms/formsprivilege/getprivileges`,
          { headers: { Authorization: `Bearer ${token}` }, params }
        );

        this.formPrivilegeItems = data;
        this.addPrivilegebutton = data.length === 0;

        // 1) unique template IDs
        const templates = [...new Set(data.map(i => i.templateId))];
        this.selectedTemplateIds = templates;

        // 2) unique role IDs
        const roles = [...new Set(data.map(i => i.roleId))];
        this.selectedRoleList = roles;

        // 3) build nested map
        const nested = {};
        roles.forEach(rid => {
          nested[rid] = {};
          templates.forEach(tid => {
            // find the specific item for (rid,tid)
            const match = data.find(
              i => i.roleId === rid && i.templateId === tid
            );
            nested[rid][tid] = match
              ? (match.privileges || []).slice()
              : [];
          });
        });
        this.rolesAndPrivilegelist = nested;
        this.temprolesAndPrivilegelist = nested;

      } catch (err) {
        console.error("Error fetching privileges:", err);
      }
    },

    async updateFormPrivilege() {
      // 1) validation
      if (this.selectedRoleList.length === 0) {
        alert(this.$t("navigations.please select role and privilege"));
        return;
      }
      if (this.selectedTemplateIds.length === 0) {
        alert(this.$t("navigations.no template selected"));
        return;
      }


      // await this.readdmissingprivileges();
      // 2) build payload using the same helper
      const payload = this.formatPrivileges(
        this.rolesAndPrivilegelist,
        this.selectedTemplateIds
      );
      this.isUpdating = true;
      // 3) send update
      try {
        await axios.put(
          `${this.baseurl}/forms/formsprivilege/update`,
          payload,
          this.head
        );
        this.isUpdating = false;
        alert(this.$t("navigations.privilege updated successfully"));
        this.listStudyTemplate();
      } catch (err) {
        console.error("Error updating privileges", err);
        alert(this.$t("navigations.failed to update privilege"));
      }
    },

    async readdmissingprivileges() {
      Object.entries(this.temprolesAndPrivilegelist).forEach(([roleId, tmplMap]) => {
        if (!this.rolesAndPrivilegelist[roleId]) {
          // whole role was removed—re-add it wholesale
          this.rolesAndPrivilegelist[roleId] = { ...tmplMap };
        } else {
          // role still there, but maybe some template keys are missing
          Object.entries(tmplMap).forEach(([templateId, savedPrivs]) => {
            if (!Array.isArray(this.rolesAndPrivilegelist[roleId][templateId])) {
              // re-add that template’s old privileges
              this.rolesAndPrivilegelist[roleId][templateId] = savedPrivs.slice();
            }
          });
        }
      });
      console.log("this.temprolesAndPrivilegelist", this.temprolesAndPrivilegelist);
      console.log("this.rolesAndPrivilegelist", this.rolesAndPrivilegelist);
      console.log("this.selectedTemplateIds", this.selectedTemplateIds);
    },
    SortSelected(sortProp, id) {
      console.log("SortPropChanged", id);
      const selectedElement = document.getElementById(id);
      const selectedElementID = document.getElementById(id).id;
      if (sortProp != null && id == selectedElementID) {
        this.sortDesc = !this.sortDesc;
        if (this.SortOrder == 0) {
          if (selectedElement.classList.contains("sortAsc")) {
            selectedElement.classList.remove("sortAsc");
            selectedElement.classList.add("sortDesc");
          } else selectedElement.classList.add("sortDesc");
        } else {
          if (selectedElement.classList.contains("sortDesc")) {
            selectedElement.classList.remove("sortDesc");
            selectedElement.classList.add("sortAsc");
          } else selectedElement.classList.add("sortAsc");
        }
      }
      this.pageindex = 1;
      this.currentPage = 1;
      this.SortTemplateProperty = sortProp;
      this.SortTemplateOrder = this.SortTemplateOrder == 0 ? 1 : 0;
      this.listStudyTemplate();
      this.initializeColumns();
    },
    SortVisit(sortProp, id) {
      console.log("SortPropChanged");
      const selectedElement = document.getElementById(id);
      const selectedElementID = document.getElementById(id).id;
      if (sortProp != null && id == selectedElementID) {
        this.sortDesc = !this.sortDesc;
        if (this.SortOrder == 0) {
          if (selectedElement.classList.contains("sortAsc")) {
            selectedElement.classList.remove("sortAsc");
            selectedElement.classList.add("sortDesc");
          } else selectedElement.classList.add("sortDesc");
        } else {
          if (selectedElement.classList.contains("sortDesc")) {
            selectedElement.classList.remove("sortDesc");
            selectedElement.classList.add("sortAsc");
          } else selectedElement.classList.add("sortAsc");
        }
      }
      this.pageindex = 1;
      this.currentPage = 1;
      this.visitSortProperty = sortProp;
      this.visitSortOrder = this.visitSortOrder == 0 ? 1 : 0;
      this.listVisit();
      this.initializeColumns();
    },
    SortActivities(sortProp, id) {
      console.log("SortPropChanged");
      const selectedElement = document.getElementById(id);
      const selectedElementID = document.getElementById(id).id;
      if (sortProp != null && id == selectedElementID) {
        this.sortDesc = !this.sortDesc;
        if (this.SortOrder == 0) {
          if (selectedElement.classList.contains("sortAsc")) {
            selectedElement.classList.remove("sortAsc");
            selectedElement.classList.add("sortDesc");
          } else selectedElement.classList.add("sortDesc");
        } else {
          if (selectedElement.classList.contains("sortDesc")) {
            selectedElement.classList.remove("sortDesc");
            selectedElement.classList.add("sortAsc");
          } else selectedElement.classList.add("sortAsc");
        }
      }
      this.pageindex = 1;
      this.currentPage = 1;
      this.SortProperty = sortProp;
      this.SortOrder = this.SortOrder == 0 ? 1 : 0;
      this.listSOAs();
      this.initializeColumns();
    },
    initializeColumns() {
      // Study Templates columns
      const allowedKeys = [
        "templateName",
        "version",
        "languageCode",
        "createdDate",
        "category",
        "language",
        "status"
      ];
      const fieldLabels = {
        templateName: "Form Name",
        version: "Version",
        createdDate: "Last updated",
        category: "Category",
        language :"Language",
        status :"Status"
      };
      const readableData = allowedKeys.map((key) => fieldLabels[key] || key);
      this.getColumns = readableData;
      this.selectedColumns = [...this.getColumns];
      this.selectedcolumnobj = this.selectedColumns.reduce((obj, key) => {
        obj[key] = true;
        return obj;
      }, {});

      // Visit columns
      const visitAllowedKeys = [
        "visitFormName",
        "visitNo"
      ];
      const visitFieldLabels = {
        visitFormName: "Visit Name",
        visitNo: "Visit No"
      };
      const visitReadableData = visitAllowedKeys.map((key) => visitFieldLabels[key] || key);
      visitReadableData.forEach((col) => {
        if (!(col in this.selectedcolumnobj)) {
          this.selectedcolumnobj[col] = true;
        }
      });

      // SoA columns
      const soaAllowedKeys = [
        "Activity Name",
        "Activity Type",
        "View Form"
      ];
      soaAllowedKeys.forEach((col) => {
        if (!(col in this.selectedcolumnobj)) {
          this.selectedcolumnobj[col] = true;
        }
      });
    },
    closeformActivityModal() {
      this.currentform = "";
      this.setshowActivityFormModal = false;

    },
    async gotoform(formid) {
      this.currentform = formid;      
      this.setshowActivityFormModal = true;
    },

    async listStudyTemplate() {
      this.ecrfLoading=true
      axios.get(`${this.baseurl}/forms/template/listtemplate?IsPrivileged=false&StudyID=${this.studyId}&pageindex=${this.currentTemplatePage}&pagesize=${this.pageSize}&SortProperty=${this.SortTemplateProperty}&SortOrder=${this.SortTemplateOrder}`, this.head)
        .then((res) => {   
          this.studyTemplates = res.data.results;
          let totalCount = res.data.totalCount;
          this.totalTemplatePages = parseInt(totalCount / this.pageSize);
          if (totalCount % this.pageSize != 0) {
            this.totalTemplatePages = this.totalTemplatePages + 1;
          }
            this.ecrfLoading=false
        })
        .catch(err =>  this.ecrfLoading=false);
    },
    uniqueBy(arr, key) {
      const seen = new Set();
      return arr.filter(o => {
        if (seen.has(o[key])) return false;
        seen.add(o[key]);
        return true;
      });
    },
    async templateList() {
      axios.get(`${this.baseurl}/forms/template/listtemplate?IsPrivileged=false&Status=Approved&StudyID=${this.studyId}&pagesize=100&SortProperty=templateName&SortOrder=0`, this.head)
        .then((res) => {
          this.permissiontemplatlist = res.data.results;
          this.templates = this.uniqueBy(this.permissiontemplatlist, "sourceTemplateId");
        })
        .catch(err => console.log("error in get template list", err));
    },
    async getPagesByTemplateId(id, version) {
      await axios.get(`${this.baseurl}/forms/templatedesign/getpagesbyid?formId=${id}&version=${version}`, this.head)
        .then((res) => {
          console.log("get pages...", res.data);
          this.newtemplate = res.data;
        })
        .catch(err => console.log("error in get pages", err))
    },
    async visitPopup(visitIdEdit, id) {
      if (id) {
        document.getElementById(id).style.display = "none"
      }
      this.showSiteModal = true
      this.visitId = visitIdEdit
    },
    async soAPopup(soAIdEdit) {
      console.log("entered", soAIdEdit)
      this.showSoAModal = true
      this.activityId = soAIdEdit
    },
    async listVisit() {
      this.visitsLoading=true
      axios.get(`${this.baseurl}/management/visit/listvisit?StudyId=${this.studyId}&StudyVersion=${this.selectedVersion}&pageindex=${this.currentVisitiPages}&pagesize=${this.pageSize}&SortProperty=${this.visitSortProperty}&${this.visitSortProperty=='visitNo' ? `ConvertToNumeric=true&`: ''}SortOrder=${this.visitSortOrder}`, this.head)
        .then((res) => {
          this.visitList = res.data.results;

          let totalCount = res.data.totalCount;
          this.totalVisitPages = parseInt(totalCount / this.pageSize);
          if (totalCount % this.pageSize != 0) {
            this.totalVisitPages = this.totalVisitPages + 1;
          }
            this.visitsLoading=false
        })
        .catch(err =>   this.visitsLoading=false);
    },
    async deleteForms(id) {
      if (confirm(this.$t('navigations.are you sure you want to delete this form?'))) {
        await axios.delete(
          `${this.baseurl}/forms/templatedesign/deleteform?formId=${id}`, this.head
        )
          .then(() => {
            alert(this.$t("navigations.form deleted successfully"))
            this.listStudyTemplate();
            this.templateList();
          })
          .catch((err) => {
            alert(this.$t("navigations.failed due to internal error"))
            console.error(err);
          });
      }
      this.showSidePopup = [false];
    },
    async deleteVist(id) {
      if (confirm(this.$t('navigations.are you sure you want to delete this visit?'))) {
        await axios.delete(`${this.baseurl}/management/visit/delete?id=${id}`, this.head)
          .then(() => {
            alert(this.$t("navigations.visit deleted successfully"));
            this.listVisit();
          })
          .catch((err) => {
            alert(this.$t("navigations.failed due to internal error"))
            console.error(err);
          });
      }
      this.showVisitPopup = [false];
    },
    async viewtemplatefun(templateFormId) {
      store.dispatch("setViewtemplateid", templateFormId);
      store.dispatch("setViewformid", templateFormId);

      this.$router.push(`/viewform/${templateFormId}`);
    },
    async openApprovalModal(){
       this.documentApprovalModal = true;
       await this.getRoleList();
    },
    async createNewVersion(templateFormId, version, sourceTemplateId, templateId,therapeuticId,formcategoryId) {
      localStorage.setItem('isStudyProfileRoute', true);
      localStorage.setItem('templateFormId', templateFormId);
      localStorage.setItem('version', version);
      localStorage.setItem('sourceTemplateId', sourceTemplateId);
      localStorage.setItem('latestTempId', templateId)
      localStorage.setItem('DesignFormPrvRoute', "studyProfile");
      localStorage.setItem('therapeuticId', therapeuticId);
      localStorage.setItem('formcategoryId', formcategoryId);
      this.$router.push({
        path: '/formdesigner',
        query: {templateId: templateId }
      });
    },

    async gettemplatedata() {
      await axios
        .get(`${this.baseurl}/forms/template/listtemplate?IsPrivileged=false&StudyID=${this.studyId}&SortProperty=templateName&SortOrder=0`, this.head)
        .then((res) => {
          this.templatelist = (res.data.results || []).sort((a, b) =>
            a.templateName.localeCompare(b.templateName)
          );
          console.log("list template data is...", this.templatelist)
        })
        .catch((err) => {
          console.log("error in get template details ", err);
        });
    },
    async assignTemplate() {
      if (this.selectedTemplateIds.length == 0) {
        alert(this.$t('navigations.please select a form'))
      }
      else {
        this.templateNameArray = []
        console.log("Value is", this.selectedmodeltemplate)
        this.selectedmodeltemplate.forEach((item, index) => {
          this.formsArray[index] = {
            "template_ID": "",
            "templateName": "",
            "version": ""
          },
            this.formsArray[index].template_ID = item.templateId
          this.formsArray[index].templateName = item.templateName
          this.formsArray[index].version = item.version
        })
        await axios
          .put(`${this.baseurl}/management/visit/assigntemplate`,
            {
              "visitID": this.selectedvisitid,
              "forms": this.formsArray
            }, this.head
          )
          .then((res) => {
            alert(this.$t('navigations.form assigned successfully'));
            console.log(res.data);
            this.formsArray = [],
              this.selectedmodeltemplate = []
            this.listVisit();
          })
          .catch((err) => {
            console.log("error in assign template", err);
          });
        this.closeTemplateModal();
      }
    },
    async createTemplate() {
      localStorage.setItem('isFormCreateTemplateRoute', true);
      this.$router.push(`/formdesigner`);
      localStorage.setItem('DesignFormPrvRoute', "studyProfile");
    },
    closecreatenewversion() {
      this.newversionformid = "";
      this.creatversionpopup = false;
    },
    async closeModal() {
      this.showSiteModal = false;
      await this.listVisit();
    },
    async closeRetireModal() {
      this.retireFormModal = false;
      await this.listStudyTemplate();
      await this.templateList();
      await this.listVisit();
    },
    async closeCategoryModal() {
      console.log("close category modal");
      await this.templateList();
      await this.listStudyTemplate();
      this.showcategoryModal = false;
    },
    async closeSoAModal() {
      await this.listSOAs();
      this.showSoAModal = false;
    },
    async openTemplateModal(visitid) {
      console.log("open template modal")
      this.selectedvisitid = visitid;
      this.showAssignTemplate = true
      await this.gettemplatedata();
      await this.getAllForms(visitid);
      if (this.formItems != null) {
        console.log("Inside map function")
        this.selectedTemplateIds = this.formItems.map(item => item.template_ID);
        console.log("selected template ids...", this.selectedTemplateIds)
      }

    },
    async closeTemplateModal() {
      this.selectedTemplateIds = [];
      this.showAssignTemplate = false;
    },
    async openFormsModal(visitid, patientId) {
      console.log("from fill form list", patientId)
      localStorage.setItem("patID", patientId)
      this.selectedvisitid = visitid;
      await this.getAllForms(visitid);
      this.showVisitForms = true;

    },
   async openActivityFormsModal(soaId) {
    this.showActivityForms = true; // open the modal
    await this.getSoA(soaId);      // fetch the data and update formItems
  },

  closeModalForms() {
    this.showActivityForms = false;
    this.formItems = [];
  },

    async openVisitActivityModal(visitid) {
      this.SelectedVisitId = visitid;
      this.showActivityModal = true;
    },
    async closeModalForms() {
      this.showVisitForms = false;
    },
    async closeActivityForms() {
      this.showActivityForms = false;
      
    },
    async getAllForms(visitId) {
      const idtoken = store.getters.getIdToken;
      await axios
        .get(
          `${this.baseurl}/management/visit/getallforms?studyId=${this.studyId}&visitId=${visitId}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.formItems = res.data;
          console.log("visit form list is...", this.formItems);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getSoA(soaId) {
      await axios
        .get(`${this.baseurl}/management/study/getsoa?Id=${soaId}`, this.head)
        .then((res) => {
          this.soAItem = res.data;
          this.values = res.data;
          console.log(" SoA created", res.data);
        })
        .catch((err) => console.log("error creating SoA"));
    },
    async onClickButton() {
      this.showLoadingAnimation = true;
      this.clicked = true;
      await this.getStudyDescription();
      this.showLoadingAnimation = false;
      this.clicked = false;
    },
    async getStudyDescription() {
      
      const studyId = store.getters.getStudyIs;
      try {
        const response = await axios.get(`${this.baseurl}/management/study/getbyid?id=${this.studyId}&version=${this.selectedVersion}`,
          this.head)

        this.StudyDescription = response.data;
        console.log("StudyDescription", this.StudyDescription);
        await this.formGeneration();

        if (Array.isArray(this.StudyDescription.studyProperties)) {
          this.FromStudy = this.StudyDescription.studyProperties;

        } else {
          console.log("No arrays found in studyProperties");
          this.FromStudy = [];
        }
      } catch (error) {
        console.log("Error in getting study:", error);
      }

    },
    async formGeneration() {
      // this.FromStudy.push(this.values.description)
      axios.get(`${this.baseurl}/forms-ml/mlmodel/getvalues?model_name=${this.values.modelName}&data=${this.StudyDescription}&threshold=${this.values.threshold}`)
        .then((res) => {
          this.formList = res.data;

          console.log("Arrays extracted from studyProperties and stored in FromStudy:", this.FromStudy);
          console.log("Form list", res.data)

          this.$router.push({
            path: '/FormSuggestions',
            query: {
              formList: encodeURIComponent(JSON.stringify(this.formList))
            }
          });
        })
        .catch(err => console.log("error in get study", err));
      await store.dispatch("setformList", JSON.stringify(this.formList))
    },
    async viewForm(id) {
      this.$router.push(`/viewTemplate/studyProfile/${id}`);
    },
    async listSOAs() {
      console.log("selectedVersion issssssss.......",this.selectedVersion)
      this.activitiesLoading=true
      await axios.get(`${this.baseurl}/management/study/listsoa?studyId=${this.studyId}&StudyVersion=${this.selectedVersion}&activityType=${this.activityType}&pageindex=${this.soaCurrentPage}&pagesize=${this.pageSize}&SortProperty=${this.SortProperty}&SortOrder=${this.SortOrder}`, this.head)
        .then((res) => {
          console.log("SoA list", res.data);
          this.SoAList = res.data.entities;

          let totalCount = res.data.totalCount;
          this.soaTotalPages = parseInt(totalCount / this.pageSize);
          if (totalCount % this.pageSize != 0) {
            this.soaTotalPages = this.soaTotalPages + 1;
          }
             this.activitiesLoading=false
        }).catch(err => {    this.activitiesLoading=false })
    },
    async deleteSoA(id, index) {
      if (confirm(this.$t("navigations.are you sure you want to delete this activity?"))) {
        await axios.delete(`${this.baseurl}/management/study/deletesoa?id=${id}`, this.head)
          .then((res) => {
            console.log(" SoA deleted", res.data);
            alert(this.$t("navigations.activity deleted successfully"))
          }).catch(() => console.log('error deleting SoA'));
      }
      this.showSoaPopup[index] = false;
      this.listSOAs();
    },
   
   async getDesignationUser(role) {
        const idtoken = store.getters.getIdToken;
        await axios
          .post(
            `${this.baseurl}/account-core/user/getuserlistbyroles?studyid=${store.getters.getStudyIs}`,
            [`${role}`],
            {
              headers: {
                Authorization: "Bearer " + idtoken,
                "Content-Type": "application/json",
              },
            }
          )
          .then((res) => {
            if (res.data && res.data.length) {
              const mergedList = [...this.userList, ...res.data];
              this.userList = mergedList
                .filter(
                  (user, index, self) =>
                    index === self.findIndex((u) => u.email === user.email) 
                )
                .sort((a, b) => a.name.localeCompare(b.name));
            }

            this.isRequired = [];
            this.isSelectedUser = [];
            this.isDisabled = [];
            this.userList.forEach((user, index) => {
              this.isRequired[index] = false;
              this.isSelectedUser[index] = false;
              this.isDisabled[index] = false;
              this.loadingSingleSave[index] = false;
            });

          })
          .catch((err) => {
            console.log(err);
          });
   },
   async activateStudy(){
    if(confirm(this.$t("navigations.are you sure you want to activate this study?"))){
      try{
        let payload={
          "studyId": this.studyId,
          "version": this.selectedVersion,
          "approvedByEmail": "",
          "approvedStatus": "",
          "actionType": "activate",
          "comments": ""
        };
        const result = await axios.put(`${this.baseurl}/management/study/changeversionstatus`,payload,this.head);
        alert(this.$t("navigations.study activated successfully"));
        await this.getStudyDetails().then(() => {
          this.updateDisabledUsers();
        });
        await this.setBtnVisibility();
        await this.listVisit();
        await this.listSOAs();
        await this.listVersionTypes(this.studyId);
      }
      catch(err){
        console.error("Error activating study:", err);
        alert(this.$t("navigations.failed to activate study"));
      }
    } 
   },
   async getUserDetails(){
    this.user = jwt_decode(store.getters.getIdToken);
   },
    async onChange(selected) {
      this.showSave = true;
      //this.approvals.approveList = [];
      //this.approvals.version = this.selectedversionid;
      this.userobject = [];
      this.userList = [];
      this.isSelectedUser = [];
      this.isRequired = [];

      if (Array.isArray(selected)) {
        for (let roleId of selected) {
          await this.getDesignationUser(roleId);
        }
      } else if (selected) {
        await this.getDesignationUser(selected);
      }
      await this.updateDisabledUsers();
   },

    selectall(event) {
      const isChecked = event.target.checked;
      this.isSelectedUser = this.userList.map((u, i) =>
        this.isDisabled[i] ? this.isSelectedUser[i] : isChecked
      );
      this.isRequired = this.userList.map(() => false);
    },

    async singleSaveApprover(user, index) {
      try {
        this.loadingSingleSave[index] = true;

        // Build payload
        const payload = {
          studyId: this.studyId,
          version: this.selectedVersion,
          actionType: "approval",
          approver: {
            approvedByName: user.name || "",
            approvedBy: user.userID || "",
            approvedByEmail: user.email || "",
            approvedByUsername: user.userName || "",
            approvedStatus: "Pending",
            approvalType: "Approval", // default empty
            approvalTypeID: "", // default empty
            approvedDate: new Date().toISOString(),
            assignedByName: "", // default empty
            dueDate: this.selectedDueDate
              ? new Date(this.selectedDueDate).toISOString()
              : null,
            isRequired: this.isRequired[index] || false,
            comments: "",
          },
        };

        const result = await axios.post(
          `${this.baseurl}/management/study/singlesaveapprover`,
          payload,
          this.head
        );

        this.loadingSingleSave[index] = false;
        alert(this.$t("navigations.approver added successfully"));
        await this.getStudyDetails();
        await this.updateDisabledUsers();
        await this.setBtnVisibility();
      } catch (err) {
        this.loadingSingleSave[index] = false;
        console.error("Error adding approver:", err);
        alert(this.$t("navigations.failed to add approver"));
      }
    },

    async multipleSaveApprover() {
      try {
        this.loadingSaveModalBtn = true;

        const selectedUsers = this.userList.filter(
          (u, i) => this.isSelectedUser[i]
        );

        if (!selectedUsers.length) {
          alert("Please select at least one user to save.");
          this.loadingSaveModalBtn = false;
          return;
        }

        const approveList = selectedUsers.map((user, i) => ({
          approvedByName: user.name || "",
          approvedBy: user.userID || "",
          approvedByEmail: user.email || "",
          approvedByUsername: user.userName || "",
          approvedStatus: "Pending",
          approvalType: "Approval",
          approvalTypeID: "",
          approvedDate: new Date().toISOString(),
          assignedByName: "",
          dueDate: this.selectedDueDate
            ? new Date(this.selectedDueDate).toISOString()
            : null,
          isRequired: this.isRequired[i] || false,
          comments: "",
        }));

        const payload = {
          studyId: this.studyId,
          version: this.selectedVersion,
          actionType: "approval",
          approveList,
        };

        const result = await axios.post(
          `${this.baseurl}/management/study/multiplesaveapprover`,
          payload,
          this.head
        );
        this.loadingSaveModalBtn = false;
        alert(this.$t("navigations.approvers added successfully"));
        await this.getStudyDetails();
        await this.updateDisabledUsers();
        await this.setBtnVisibility();
        this.documentApprovalModal = false;
      } catch (err) {
        this.loadingSaveModalBtn = false;
        console.error("Error adding approvers:", err);
        alert(this.$t("navigations.failed to add approvers"));
      }
    },
    updateDisabledUsers() {
      if (!this.studyDetails || !this.selectedVersion) return;

      const selectedVersionObj = this.studyDetails.versions.find(
        v => v.version === this.selectedVersion
      );

      if (!selectedVersionObj || !Array.isArray(selectedVersionObj.approval)) {
        this.existingApprovers = [];
        this.isDisabled = this.userList.map(() => false);
        return;
      }
      this.existingApprovers = selectedVersionObj.approval
        .filter(a => a.approvedStatus === "Approved" || a.approvedStatus === "Pending")
        .map(a => a.approvedByEmail);

      this.isDisabled = this.userList.map(u =>
        this.existingApprovers.includes(u.email)
      );
      
      this.isSelectedUser = this.userList.map((u, i) =>
        this.isDisabled[i] ? false : this.isSelectedUser[i]
      );
    },
    async openApproveModal(){
      this.showApproveRejectPopup = true;
    },
    async closeApproveModal(){
      await this.getStudyDetails().then(() => {
        this.updateDisabledUsers();
      });
      await this.setBtnVisibility();
      await this.listVisit();
      await this.listSOAs();
      this.showApproveRejectPopup = false;
    },
    async setBtnVisibility() {
      this.showActivateBtn = false;
      this.showApproveBtn = false;

      try {
        if (!this.studyDetails || !this.studyDetails.versions) { return; }
        const currentVersion = this.studyDetails.versions.find(
          v => v.version === this.selectedVersion
        );

        this.selectedVersion = currentVersion.version;
        if (!currentVersion) {
          return;
        }
        console.log("Current Version in setBtnVisibility:", currentVersion);
        if (this.user && this.user.email) {
          //Active button visibility

          if( (currentVersion.approval == null || currentVersion.approval == undefined) && (this.user.email == this.currentVersion.createdUserEmail) ){
            console.log("............0,0..............");
            this.showActivateBtn = true;
          }
          else if((currentVersion.approval == null || currentVersion.approval == undefined) && (this.user.email != this.currentVersion.createdUserEmail) ){
            console.log("............0,1..............");
            this.showActivateBtn = false;
          }
          else {
            console.log("............1,1..............");
            const requiredApprovals = currentVersion.approval.filter(a => a.isRequired === true);
            if (requiredApprovals.length === 0 && !currentVersion.isActive) {
              this.showActivateBtn = true;
            } else {
              const allRequiredApproved = requiredApprovals.every(
                a => a.approvedStatus === "Approved" 
              );

              const anyPendingRequired = requiredApprovals.some(
                a => a.approvedStatus === "Pending"
              );

              this.showActivateBtn = allRequiredApproved && !anyPendingRequired && !currentVersion.isActive;
            }
          }
          
          // Approve button visibility
          const userApprovalPending = currentVersion.approval.some(
            a => a.approvedByEmail === this.user.email && a.approvedStatus === "Pending" && currentVersion.isActive === false
          );
          this.showApproveBtn = userApprovalPending;
        } else {
          this.showApproveBtn = false;
        }

      } catch (err) {
        console.error("Error in setBtnVisibility:", err);
        this.showActivateBtn = false;
        this.showApproveBtn = false;
      }
    }

  },
};